import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { idFromPrefix } from '@@client/lib/forms';
import Modal from '@@client/components/Modal';
import PartSearchForm from '@@client/parts/PartSearchForm';
export default function PartSearchModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      _ref$partTypeSlug = _ref.partTypeSlug,
      partTypeSlug = _ref$partTypeSlug === void 0 ? '' : _ref$partTypeSlug,
      _ref$year = _ref.year,
      year = _ref$year === void 0 ? '' : _ref$year,
      _ref$make = _ref.make,
      make = _ref$make === void 0 ? '' : _ref$make,
      _ref$carline = _ref.carline,
      carline = _ref$carline === void 0 ? '' : _ref$carline,
      _ref$application = _ref.application,
      application = _ref$application === void 0 ? '' : _ref$application,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      _ref$doClearSearch = _ref.doClearSearch,
      doClearSearch = _ref$doClearSearch === void 0 ? function () {} : _ref$doClearSearch;
  var idPrefix = 'part-search-modal';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Modal, {
      className: "no-body-styles",
      initialFocus: '#' + idFromPrefix(idPrefix, 'partType'),
      isOpen: isOpen,
      onClose: onClose,
      title: "Change Search Vehicle",
      children: /*#__PURE__*/_jsx("div", {
        className: "jsx-1351856469" + " " + 'container m--gradient--blue--medium',
        children: /*#__PURE__*/_jsx("div", {
          className: "jsx-1351856469" + " " + 'the-form',
          children: /*#__PURE__*/_jsx(PartSearchForm, {
            idPrefix: idPrefix,
            partTypeSlug: partTypeSlug,
            year: year,
            make: make,
            carline: carline,
            application: application,
            onChange: onChange,
            onSubmit: onSubmit,
            doClearSearch: doClearSearch,
            scrollOptionsIntoView: true
          })
        })
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1351856469",
      children: [".container.jsx-1351856469{padding:20px;overflow-y:scroll;}", "@media(min-width:576px){.container.jsx-1351856469{padding:20px 65px;}}", "@media(max-width:575px){.the-form.jsx-1351856469{width:350px;}}", "@media(max-width:504px){.the-form.jsx-1351856469{width:100%;}}", "@media(min-width:576px){.the-form.jsx-1351856469{width:325px;}}", ".the-form.jsx-1351856469 .actions button{margin-top:10px;width:100%;}"]
    })]
  });
}